"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgCommentDots(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M12 1c6.589 0 12 4.162 12 9.407 0 5.258-5.429 9.487-12 9.487h-1.604l-.04.064c-.616.92-1.527 1.613-2.65 2.113l-.286.12c-.783.317-1.614.527-2.443.653a11.12 11.12 0 01-.887.101l-.24.012a.766.766 0 01-.618-1.244c.052-.065.151-.198.283-.39.222-.324.444-.687.652-1.076.474-.89.79-1.773.89-2.593l.003-.05C2.265 16.293.13 13.608.006 10.675L0 10.407C0 5.162 5.411 1 12 1zm0 1.532c-5.818 0-10.468 3.577-10.468 7.875 0 2.523 2.018 4.966 4.608 5.998a.766.766 0 01.482.712c0 1.257-.416 2.56-1.103 3.85l-.134.242.221-.047c.284-.067.564-.147.837-.24l.404-.15c1.136-.46 1.976-1.117 2.43-1.996a.766.766 0 01.68-.414H12c5.797 0 10.468-3.639 10.468-7.955 0-4.298-4.65-7.875-10.468-7.875zM7.915 9.936a1.021 1.021 0 110 2.043 1.021 1.021 0 010-2.043zm4.085 0a1.021 1.021 0 110 2.043 1.021 1.021 0 010-2.043zm4.085 0a1.021 1.021 0 110 2.043 1.021 1.021 0 010-2.043z",
    fill: "inherit",
    fillRule: "evenodd"
  }));
}

var _default = SvgCommentDots;
exports.default = _default;